import _slicedToArray from "D:/wenge-Obj/zhichuan/llm-agent-web/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectSpread from "D:/wenge-Obj/zhichuan/llm-agent-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "D:\\wenge-Obj\\zhichuan\\llm-agent-web\\node_modules\\core-js\\modules\\es.array.iterator.js";
import "D:\\wenge-Obj\\zhichuan\\llm-agent-web\\node_modules\\core-js\\modules\\es.promise.js";
import "D:\\wenge-Obj\\zhichuan\\llm-agent-web\\node_modules\\core-js\\modules\\es.object.assign.js";
import "D:\\wenge-Obj\\zhichuan\\llm-agent-web\\node_modules\\core-js\\modules\\es.promise.finally.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from '@/locales/index';
import axios from 'axios';
import { applyAcceptLanguageHeader } from '@/utils/requestLanguage';
import { EventBus } from '@/utils/eventBus.js';
import '@/assets/iconpark.js';
import '@/assets/iconfont/iconfont.js';
// 2. 立即加载的全局样式（关键CSS）
import '@/assets/scss/reset.scss'; // 注意：建议压缩为critical.css只包含首屏样式
import 'element-ui/lib/theme-chalk/index.css'; //element-ui样式
// wangeditor
import '@wangeditor/editor/dist/css/style.css';
// 第三方包
import ElementUI from 'element-ui';
Vue.use(ElementUI);
applyAcceptLanguageHeader({
  headers: axios.defaults.headers.common
}, i18n.locale);
Vue.prototype.$EventBus = EventBus;
//Message全局提示时常
import { Message } from 'element-ui';
Vue.prototype.$message = Message;
// 覆盖默认的 $message
Vue.prototype.$message = function (options) {
  if (typeof options === 'string') {
    options = {
      message: options,
      duration: 1000 // 默认2秒
    };
  } else {
    options.duration = options.duration || 1000; // 允许调用时自定义
  }
  return Message(options);
};
['success', 'warning', 'error', 'info'].forEach(function (type) {
  Vue.prototype.$message[type] = function (options) {
    if (typeof options === 'string') {
      options = {
        message: options,
        duration: 1500
      };
    }
    return Message(_objectSpread(_objectSpread({}, options), {}, {
      type: type,
      duration: options.duration || 1000
    }));
  };
});
Vue.directive('permission', {
  inserted: function inserted(el, binding) {
    var permission = JSON.parse(sessionStorage.getItem('permission') || '[]');
    var permissionButton = filterPermissions(permission);
    var treeToArray1 = treeToArray(permissionButton);
    var item = treeToArray1.find(function (n) {
      return n.menuCode === binding.value;
    });
    if (!item) {
      el.style.display = 'none';
    }
  }
});
Vue.directive('removeAriaHidden', {
  bind: function bind(el) {
    var ariaEls = el.querySelectorAll('.el-radio__original');
    ariaEls.forEach(function (item) {
      item.removeAttribute('aria-hidden');
    });
  }
});

// 1. 最简化的核心初始化
var app = new Vue({
  router: router,
  store: store,
  i18n: i18n,
  render: function render(h) {
    return h(App);
  }
}).$mount('#app');
window.app = app;

// 3. 异步加载第三方库和组件（按需加载）
setTimeout(function () {
  // 3.2 异步加载axios配置
  import('@/api/config').then(function (http) {
    Vue.prototype.$http = http.default;
  });
  // 3.3 异步加载富文本编辑器相关资源
  Promise.all([import('@wangeditor/editor/dist/css/style.css'), import('highlight.js/styles/github.css')]);

  // 3.4 异步加载CodeMirror
  Promise.all([import("codemirror/lib/codemirror.css"), import("codemirror/theme/3024-day.css"), import("codemirror/theme/ayu-mirage.css"), import("codemirror/theme/monokai.css"), import('codemirror/theme/rubyblue.css'), import('vue-codemirror').then(function (_ref) {
    var codemirror = _ref.codemirror;
    Vue.component("codemirror", codemirror);
  })]);
  // 3.6 异步加载markdown编辑器
  import('@kangc/v-md-editor/lib/preview').then(function (VMdPreview) {
    Promise.all([import('@kangc/v-md-editor/lib/style/preview.css'), import('@kangc/v-md-editor/lib/theme/github'), import('@kangc/v-md-editor/lib/theme/style/github.css'), import('highlight.js')]).then(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 4),
        _ = _ref3[0],
        githubTheme = _ref3[1],
        __ = _ref3[2],
        hljs = _ref3[3];
      VMdPreview.default.use(githubTheme.default, {
        Hljs: hljs.default
      });
      Vue.use(VMdPreview.default);
    });
  });
}, 0);
// 过滤权限
function filterPermissions(permission) {
  return permission.filter(function (item) {
    return !item.clientType || item.clientType === "saas-pc";
  }).filter(function (item) {
    return item.isHidden !== 1;
  }).map(function (item) {
    if (item.children) {
      item.children = filterPermissions(item.children);
    }
    return item;
  });
}

// 将树形解析成数组
function treeToArray(data) {
  var temp = [];
  data.forEach(function (item) {
    if (item.children) {
      temp = temp.concat(treeToArray(item.children));
    }
    temp.push(item);
  });
  return temp;
}
Vue.config.productionTip = false;
export default app;